import ScreenLoading from "./components/helpers/ScreenLoading";
import { Suspense, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./hooks/use-auth";
import ErrorBoundary from "./routing/ErrorBoundary";
import { AuthGuard } from "./guards/AuthGuard";
import { GuestGuard } from "./guards/GuestGuard";
import useIsOnline from "./hooks/use-onoffline";
import ErrorMessageCard from "./components/helpers/ErrorMessageCard";
import { Box } from "@mui/material";
import { paths } from "./paths";
import LoginPage from "./pages/auth/LoginPage";
import DeleteMyAccountPage from "./pages/auth/DeleteMyAccountPage";
import MainLayout from "./layouts/main/MainLayout";
import PrivacyPage from "./pages/auth/PrivacyPage";
import SupportPage from "./pages/auth/SupportPage";
import TermsPage from "./pages/auth/TermsPage";
import DownloadAppPage from "./pages/DownloadAppPage";

function App() {
  const { loading, initialize } = useAuth();
  const isOnline = useIsOnline();
  useEffect(() => {
    try {
      const unsubscribe = initialize();
      return () => {
        unsubscribe();
      };
    } catch (error) {
      console.error(error);
    }
  }, [initialize]);

  return (
    <ErrorBoundary>
      <Suspense fallback={<ScreenLoading />}>
        {!isOnline ? (
          <Box
            sx={{
              padding: 2,
            }}
          >
            <ErrorMessageCard errorMessage="You are offline" />
          </Box>
        ) : loading ? (
          <ScreenLoading />
        ) : (
          <Routes>
            {/* Main routes  --  Protected by AuthGuard */}
            <Route
              element={
                <AuthGuard>
                  <MainLayout />
                </AuthGuard>
              }
            >
              <Route
                path={paths.auth.deleteMyAccount}
                element={<DeleteMyAccountPage />}
              />
            </Route>
            {/* Auth routes  --  Protected by GuestGuard */}
            <Route
              element={
                <GuestGuard>
                  <MainLayout />
                </GuestGuard>
              }
            >
              <Route path={paths.auth.login} element={<LoginPage />} />
            </Route>
            <Route element={<MainLayout />}>
              <Route index element={<Navigate to={paths.privacy} replace />} />
              <Route path={paths.support} element={<SupportPage />} />
              <Route path={paths.privacy} element={<PrivacyPage />} />
              <Route path={paths.terms} element={<TermsPage />} />
              <Route path={paths.download} element={<DownloadAppPage />} />
            </Route>
            {/* Redirect to home if route not found */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        )}
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
